import { z } from 'zod';

export const hrefSchema = z
    .string()
    .trim()
    .min(1, 'Ссылка обязательна')
    .refine(
        val => val.startsWith('/') || /^https?:\/\/.+/i.test(val),
        'Ожидается абсолютный URL (http/https) или путь, начинающийся с "/"',
    );

export type HrefSchema = z.infer<typeof hrefSchema>;
